import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

const buildingsNorthAfrica: LayerRaw = {
  id: 'MicrosoftBuildings',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms',
  title: {
    'en-US': 'Microsoft Buildings',
    'pt-BR': 'Edifícios da Microsoft',
    'es-ES': 'Edificios de Microsoft',
    'fr-FR': 'Bâtiments Microsoft'
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  customProperties: { group: 'reference' },
  legend: {
    title: 'n/a'
  },
  minZoomLevel: 12,
  sublayers: [
    {
      id: 'naf:NAF_MS_Buildings',
      visible: true,
      legend: {
        title: {
          'en-US': 'Microsoft Buildings',
          'pt-BR': 'Edifícios da Microsoft',
          'es-ES': 'Edificios de Microsoft',
          'fr-FR': 'Bâtiments Microsoft'
        },
        items: [
          {
            icon: 'mdi-vector-polygon',
            color: '#000000',
            text: {
              'en-US': 'Microsoft Buildings',
              'pt-BR': 'Edifícios da Microsoft',
              'es-ES': 'Edificios de Microsoft',
              'fr-FR': 'Bâtiments Microsoft'
            }
          }
        ]
      }
    }
  ],
  icon: 'mdi-home-city'
}

export default buildingsNorthAfrica
